export default class InitialData {
    static minaylaUrl = 'https://minayla.com/'
}



// WEBPACK FOOTER //
// ./src/components/InitialData.js